module.exports = __webpack_public_path__ + "store/img/product-tag-hrt-thumbnail.515ae216.png";